<template>
    <div class="re-form flex column center">
        <div class="md-container">
            <div class="flex row center">
                <div>
                    <input v-model="first_name" class="re-name-input re-input" type="text" placeholder="First Name">
                </div>
                <div>
                    <input v-model="last_name" class="re-phone-input re-input" type="text" placeholder="Last Name">
                </div>
            </div>
            <div class="flex row center">
                <div>
                    <input v-model="phone" class="re-phone-input re-input" type="tel" placeholder="Phone Number">
                </div>
                <div>
                    <input v-model="code" class="re-name-input re-input" type="text" placeholder="Referral Code">
                </div>
            </div>
            <div>
                <input v-model="email" class="re-email-input re-input" type="email" placeholder="Email Address">
            </div>
        </div>
        <div class="mobile-form column">
            <div>
                <input v-model="first_name" class="re-name-input re-input" type="text" placeholder="First Name">
            </div>
            <div>
                <input v-model="last_name" class="re-name-input re-input" type="text" placeholder="Last Name">
            </div>
            <div>
                <input v-model="phone" class="re-phone-input re-input" type="tel" placeholder="Phone Number">
            </div>
            <div>
                <input v-model="code" class="re-phone-input re-input" type="text" placeholder="Referral Code">
            </div>
            <div>
                <input v-model="email" class="re-email-input re-input" type="email" placeholder="Email Address">
            </div>
        </div>
        <div class="re-text" style="margin-top: 20px; "><i class="fas fa-certificate" style="color: #DAAE3E;"></i> Sign up now and get 50% off your service fees for life!</div>
        <div class="re-button-container">
            <button @click="submit_form()" class="re-button">GET EARLY ACCESS</button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data () {
            return {
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                code: ''
            }
        },
        methods: {
            submit_form: function() {
                const form_data = {
                    'email': this.email,
                    'name': this.first_name + ' ' + this.last_name,
                    'phone': this.phone,
                    'code': this.code
                }
                axios.post('/beta/signups', form_data)
                    .then(res => {
                        this.first_name = ''
                        this.last_name = ''
                        this.phone = ''
                        this.email = ''
                        this.code = ''
                        this.showSuccessMsg()
                    })
                    .catch(error => console.log(error))
            }
        },
        mounted() {
            if (this.$route.query.ref)
                this.code = this.$route.query.ref
        },
        notifications: {
            showSuccessMsg: {
                type: 'success',
                title: 'Thank you!',
                message: 'Thanks for signing up. Look out for more information on our upcoming beta.'
            }
        }
    }
</script>

<style>
    @media (max-width: 880px) {
        .mobile-form {
            display: flex !important;
        }

        .re-input {
            width: 85vw !important;
            margin: 18px 0 !important;
        }
    }

    .mobile-form {
        display: none;
    }

    .re-form { 
        margin: 15px 0 0 0;
    }

    .re-name-input {
        height: 36px;
        width: 284px;
        background-color: #FFFFFF;
        margin: 15px;
    }

    .re-input{
        padding: 0 0 0 15px;
        outline: none;
    }

    .re-input::placeholder {
        color: #333333;	
        font-family: Trirong;	
        font-size: 12px;	
        font-weight: 500;	
        letter-spacing: 1.5px;	
        line-height: 20px;
    }

    .re-phone-input {
        height: 36px;
        width: 284px;
        background-color: #FFFFFF;
        margin: 15px;
    }

    .re-email-input {
        height: 36px;
        width: 617px;
        background-color: #FFFFFF;
        margin: 15px;
    }

    .re-button-container{
        margin: 25px;
    }

    .re-button {
        height: 52px;
        width: 226px;
        background-color: #244F76;
        color: #FFFFFF;
        font-family: Oswald;
        font-size: 11px;
        font-weight: 500;
        letter-spacing: 3.67px;
        line-height: 15px;
        border: 0px;
        cursor: pointer;
        outline: none;
    }

    .swal-button {
        padding: 7px 19px;
        border-radius: 2px;
        background-color: #244F76;
        font-size: 12px;
        border: 1px solid #3e549a;
        text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3);
    }

    .swal-button:hover {
        background-color: rgb(49, 106, 160) !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Form.vue